import React from "react";
import s from "../layers-menu.module.scss";
import { useTranslation } from "react-i18next";
import howToUse from "../../../../images/how-to-use-icon.svg";

export default function HowToUse({ is3D }: { is3D: boolean }) {
  const { t } = useTranslation();

  return (
    <div className={s.howToUseContainer}>
      <img src={howToUse} />
      {is3D ? (
        <p>
          {t("howToUse.moveAround")}
          <br />
          {t("howToUse.rotateMap")}
          <br />
          {t("howToUse.scrollMap3D")}
          <br />
          {t("howToUse.tiltAndDrag")}
        </p>
      ) : (
        <p>
          {t("howToUse.moveAround")}
          <br />
          {t("howToUse.rotateMap")}
          <br />
          {t("howToUse.scrollMap2D")}
        </p>
      )}
    </div>
  );
}
